/**
 * Per-route SEO metadata for Bag Dash Kids.
 * Title + description are tuned for the page's actual content so search
 * engines and AI crawlers can distinguish each URL.
 *
 * Keep titles under ~60 characters and descriptions between 120–160 chars.
 */
export const SITE_NAME = "Bag Dash Kids";
export const SITE_URL = "https://bagdashkids.com";

export const ROUTE_SEO = {
  "/": {
    title: "Bag Dash Kids | Friday & Saturday Trash Bag Pickup, Charlotte NC",
    description:
      "Bag Dash Kids picks up your trash bags Friday and Saturday when valet trash takes a break. Youth-run, parent-supervised, $3 for 1 bag, $5 for 2.",
  },
  "/schedule": {
    title: "Schedule a Pickup | Bag Dash Kids",
    description:
      "Book a one-time or weekly trash bag pickup in your apartment community. Friday AM, Friday PM, Saturday AM, or Saturday PM windows. Pay securely via Stripe.",
  },
  "/quick-pay": {
    title: "Quick Pay — Kids at Your Door | Bag Dash Kids",
    description:
      "Already met Big Sib Josiah or Lil Sib Jayla at your door? Pay on the spot — no login needed. $3 for 1 bag, $5 for 2, plus optional tips.",
  },
  "/login": {
    title: "Log In | Bag Dash Kids",
    description:
      "Log in to schedule pickups, track loyalty points, manage your weekly plan, and earn Dash Rewards with Bag Dash Kids.",
  },
  "/register": {
    title: "Create an Account | Bag Dash Kids",
    description:
      "Sign up free to schedule pickups, earn Dash Rewards points, refer neighbors for credit, and unlock free monthly bin cleanings as a loyal customer.",
  },
  "/about": {
    title: "Meet the Bag Dash Kids — Josiah, Jayla & Mom Manager Donja",
    description:
      "Meet Big Sib Josiah, Lil Sib Jayla, and Mom Manager Donja — the family behind Bag Dash Kids. Youth-led, faith-rooted, building entrepreneurship one bag at a time.",
  },
  "/contact": {
    title: "Contact Bag Dash Kids — Trash Pickup in Charlotte NC",
    description:
      "Questions about pickups, billing, or community service requests? Reach the Bag Dash Kids team. Parent-managed, kid-operated, mobile-friendly support.",
  },
  "/reviews": {
    title: "Customer Reviews | Bag Dash Kids",
    description:
      "Read real reviews from neighbors who trust Bag Dash Kids with their Friday and Saturday trash pickups in Charlotte-area apartment communities.",
  },
  "/reviews/new": {
    title: "Leave a Review | Bag Dash Kids",
    description:
      "Help Big Sib Josiah and Lil Sib Jayla grow — share your Bag Dash Kids experience and earn Dash Rewards points for verified customer reviews.",
  },
  "/map": {
    title: "Service Area Map | Bag Dash Kids",
    description:
      "See the apartment and townhome communities Bag Dash Kids serves on Friday and Saturday pickup days. Currently active in Hawthorne at Whitehall and expanding.",
  },
  "/policies": {
    title: "Policies, Pricing & FAQ | Bag Dash Kids",
    description:
      "Bag Dash Kids pricing ($3/$5), weekly subscription terms, cancellation, refund policy, safety rules, and FAQs about youth-led trash pickup service.",
  },
  "/leaderboard": {
    title: "Dash Rewards Leaderboard | Bag Dash Kids",
    description:
      "See which neighbors are racking up the most Dash Rewards points this week. Earn points for every pickup, referral, review, and weekly subscription.",
  },
  "/rules": {
    title: "Service Rules & What We Pick Up | Bag Dash Kids",
    description:
      "Tied household trash bags only. No hazardous waste, broken glass, sharp items, or leaking bags. See full Bag Dash Kids safety rules.",
  },
  "/quick-pay/done": {
    title: "Quick Pay Complete | Bag Dash Kids",
    description:
      "Thanks for paying Bag Dash Kids on the spot. Your tip goes straight to Big Sib Josiah and Lil Sib Jayla. Receipt sent to your email.",
  },
  "/confirmation": {
    title: "Order Confirmed | Bag Dash Kids",
    description:
      "Your Bag Dash Kids pickup is confirmed. We'll be there during your chosen window — Friday or Saturday.",
  },
  "/dashboard": {
    title: "My Dashboard | Bag Dash Kids",
    description:
      "View upcoming pickups, past orders, Dash Rewards balance, loyalty status, and referral code in your Bag Dash Kids customer dashboard.",
  },
  "/calendar": { title: "My Pickup Calendar | Bag Dash Kids" },
  "/plan": { title: "My Weekly Plan | Bag Dash Kids" },
  "/billing": { title: "Billing & Receipts | Bag Dash Kids" },
  "/notifications": { title: "Notifications | Bag Dash Kids" },
  "/community": { title: "My Community | Bag Dash Kids" },
  "/contest": {
    title: "Active Contest | Bag Dash Kids",
    description:
      "Join the current Bag Dash Kids contest — refer the most neighbors or stack the most pickups this month to win a free monthly bin cleaning.",
  },
  "/settings": { title: "Account Settings | Bag Dash Kids" },
  "/admin": { title: "Admin Dashboard | Bag Dash Kids", description: "Internal." },
  "/worker": { title: "Today's Dash Route | Bag Dash Kids", description: "Internal kid worker route view." },
};

const DEFAULT = ROUTE_SEO["/"];

export function getRouteSeo(pathname) {
  // Direct match first
  if (ROUTE_SEO[pathname]) return ROUTE_SEO[pathname];
  // Prefix match for nested routes (e.g. /checkout/:orderId)
  if (pathname?.startsWith("/checkout")) return ROUTE_SEO["/confirmation"];
  if (pathname?.startsWith("/quick-pay")) return ROUTE_SEO["/quick-pay"];
  if (pathname?.startsWith("/reviews/")) return ROUTE_SEO["/reviews/new"];
  return DEFAULT;
}
